// @flow
import { createInstance } from 'common/modules/i18n';

import enStrings from 'i18n-data-files/industry/default/en-US/strings.json';

const i18n = createInstance(enStrings);

export default i18n;

export { enStrings };
